import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Container from "@mui/material/Container";
import { EmtTheme } from "../types";
import { Breakpoint } from "@mui/system";

export type EmtHeaderProps = BoxProps & {
  background?: string;
  nonce?: string;
  backgroundColor?: string;
  containerMaxWidth?: Breakpoint | false;
  noRNMargin?: boolean;
};

type WrapperProps = BoxProps & {
  background?: string;
  theme?: EmtTheme;
  backgroundColor?: string;
};

const Header = styled(Box)((props: WrapperProps) => {
  const {
    theme,
    background = "",
    backgroundColor = `${theme?.palette.primary.main}`,
  } = props;
  return {
    background: `url('${background}'), ${backgroundColor}`,
    backgroundRepeat: "repeat",
    backgroundSize: "80%",
    width: "100%",
    padding: "38px 0",
  };
});

export function EmtHeader(props: EmtHeaderProps) {
  const { children, containerMaxWidth = "lg", noRNMargin, ...rest } = props;
  return (
    <Header {...rest}>
      <Container
        className={!noRNMargin ? "EmtReactNativeWebViewMarginTop" : ""}
        maxWidth={containerMaxWidth}
      >
        {children}
      </Container>
    </Header>
  );
}
